import React from 'react';

function TemplateCard({ item }) {
  return (
    <div
      className="item"
      style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          height: '220px',
        }}
      >
        {item.coverImg ? (
          <img
            src={item.coverImg}
            alt={item.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.4s ease',
            }}
            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.05)')}
            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
          />
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'rgba(255,255,255,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'rgba(255,255,255,0.2)',
              fontSize: '48px',
            }}
          >
            <i className="ti-image"></i>
          </div>
        )}
        {item.category && (
          <span
            style={{
              position: 'absolute',
              top: '12px',
              left: '12px',
              background: 'var(--main-color)',
              color: '#fff',
              fontSize: '11px',
              fontWeight: '600',
              padding: '4px 10px',
              borderRadius: '20px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {item.category}
          </span>
        )}
      </div>
      <div style={{ padding: '24px' }}>
        <h5 className="mb-10">{item.title}</h5>
        {item.desc && (
          <p className="p-color fz-14 mb-20" style={{ lineHeight: '1.6' }}>
            {item.desc}
          </p>
        )}
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="butn-crev d-flex align-items-center"
        >
          <span className="hover-this">
            <span className="circle hover-anim">
              <i className="ti-arrow-top-right"></i>
            </span>
          </span>
          <span className="text">Demoya Git</span>
        </a>
      </div>
    </div>
  );
}

export default TemplateCard;
